// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"2a7d8118","127":"e295d5f4","194":"cb049b42","195":"9fdaa96d","325":"183b3dad","453":"25ad6a17","553":"c596eef8","575":"65854054","859":"19c0178d"}[chunkId] + ".chunk.js";
};